import { render } from "@wordpress/element";
import { Block } from "./block";

window.addEventListener("DOMContentLoaded", () => {
	const selector = ".wp-block-steam-blocks-articles";

	const nodes = document.querySelectorAll(selector);

	nodes.forEach((node) => {
		const attributes = { ...node.dataset };

		render(<Block {...attributes} />, node);
	});
});
